import axiosInterceptorInstance from "@/elements/axiosInterceptorInstance";
import LivePriceBox from "@/elements/LivePriceBox/LivePriceBox";
import NseOrBsePrice from "@/elements/NseOrBsePrice/NseOrBsePrice";
import { cn } from "@/lib/utils";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import { BuySellBtnStockDetails } from "../PlaceOrder/BuySellBtn";
import { useSubscription } from "react-stomp-hooks";
import { Button } from "../ui/button";
import { useRouter } from "next/router";
import moment from "moment";

export default function StockTopDetails({
    finCode,
    activeChartType,
    setActiveChartType,
    preData,
    isPaidUserPage,
    isFutures = false
}) {
    const { push, asPath } = useRouter();
    const [data, setData] = useState(preData);
    useEffect(() => {
        axiosInterceptorInstance.get(`/resources/stock-details/prices-app?finCodes=${[finCode]}`).then((res) => {
            let stockDatas = res.data?.data?.list?.[0];
            if (stockDatas) {
                let obj = stockDatas;
                setData(obj);
            }
        });
    }, [finCode]);
    useSubscription(`/stock/live-price-with-exchange/${activeChartType === 1 ? "NSE" : "BSE"}/${finCode}`, (res) => {
        setData((pre) => ({
            ...pre,
            nseLtpPrice: activeChartType === 1 ? JSON.parse(res.body ?? "{}")?.ltpPrice : pre.nseLtpPrice,
            bseLtpPrice: activeChartType === 1 ? pre.bseLtpPrice : JSON.parse(res.body ?? "{}")?.ltpPrice
        }));
    });

    return (
        <div
            className={cn("p-4  ", {
                "sticky top-0 z-[9] overflow-hidden bg-white shadow-sm": isPaidUserPage
            })}
        >
            <div className="flex flex-row justify-between">
                <div className="flex justify-between md:w-full  ">
                    <div className="flex items-center">
                        <div className="h-12 w-12 grid place-content-center">
                            {data.logoUrl === null || data.logoUrl === "" ? (
                                <div className="h-12 w-12 font-Inter font-extrabold text-[24px] text-[#606060] bg-[#ededed] text-center  rounded-full flex justify-center items-center">
                                    {data.compName?.slice(0, 1)}
                                </div>
                            ) : (
                                <Image
                                    src={data.logoUrl}
                                    alt="stock logo"
                                    width={48}
                                    height={48}
                                    className="max-h-12 max-w-12 "
                                />
                            )}
                        </div>
                        <div className="ml-3 ">
                            <div className="flex items-center gap-1 mb-1 lg:mb-1.5">
                                <div className="font-Inter font-extrabold text-base text-[#0D0D0D] leading-[24px] mr-2">
                                    {data?.titleWithSubtitle}
                                </div>
                                <div className="lg:flex overflow-hidden max-h-6 hidden rounded">
                                    {!!data.nseSymbol && (
                                        <button
                                            className={cn(
                                                "px-2 py-0.5 lg:px-3 lg:py-[3px] text-[#747474] text-xs font-bold transition border rounded-s",
                                                {
                                                    "bg-primary border-primary text-white": activeChartType === 1
                                                }
                                            )}
                                            onClick={() => setActiveChartType(1)}
                                        >
                                            {isFutures ? "NFO" : "NSE"}
                                        </button>
                                    )}
                                    {!!data.bseSymbol && (
                                        <button
                                            className={cn(
                                                "px-2 py-0.5 lg:px-3 lg:py-[3px] text-[#747474] text-xs font-bold transition border rounded-e",
                                                {
                                                    "bg-primary border-primary text-white": activeChartType !== 1
                                                }
                                            )}
                                            onClick={() => setActiveChartType(2)}
                                        >
                                            {isFutures ? "BFO" : "BSE"}
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center gap-1">
                                <LivePriceBox
                                    ltpPrice={activeChartType === 1 ? data?.nseLtpPrice : data?.bseLtpPrice}
                                    textClass="font-bold text-base text-black text-right"
                                />
                                <NseOrBsePrice
                                    nseLtpPrice={activeChartType === 1 ? data?.nseLtpPrice : data?.bseLtpPrice}
                                    nseClosePrice={activeChartType === 1 ? data?.nseClosePrice : data?.bseClosePrice}
                                    textClass=" text-sm font-semibold text-right whitespace-nowrap"
                                    isIcon={true}
                                />
                            </div>
                        </div>
                    </div>
                    {data?.segment !== "I" && (
                        <div className="hidden md:block">
                            {isPaidUserPage ? (
                                <>
                                    <BuySellBtnStockDetails
                                        type="SELL"
                                        finCode={finCode}
                                        exchange={activeChartType === 1 ? "NSE" : "BSE"}
                                        className="ml-auto"
                                    />
                                    <BuySellBtnStockDetails
                                        type="BUY"
                                        finCode={finCode}
                                        exchange={activeChartType === 1 ? "NSE" : "BSE"}
                                        className="ml-2 lg:ml-4"
                                    />
                                </>
                            ) : (
                                <>
                                    <Button
                                        variant="outline"
                                        className={cn(
                                            "p-0 border-none w-12 lg:w-[118px] h-7 lg:h-10 text-xs lg:text-base font-bold text-white hover:text-white bg-[#26A649] hover:bg-[#26A649BF] ml-auto"
                                        )}
                                        onClick={() => {
                                            push(`/user/log-in?redirectUrl=${asPath}`);
                                        }}
                                    >
                                        Buy
                                    </Button>
                                    <Button
                                        variant="outline"
                                        className={cn(
                                            "p-0 border-none w-12 lg:w-[118px] h-7 lg:h-10 text-xs lg:text-base font-bold text-white hover:text-white bg-[#EB4E2C] hover:bg-[#EB4E2CBF] ml-2 lg:ml-4"
                                        )}
                                        onClick={() => {
                                            push(`/user/log-in?redirectUrl=${asPath}`);
                                        }}
                                    >
                                        Sell
                                    </Button>
                                </>
                            )}
                        </div>
                    )}
                </div>
                <div className="flex overflow-hidden ml-3 max-h-6 md:hidden rounded">
                    {!!data.nseSymbol && (
                        <button
                            className={cn(
                                "px-2 py-0.5 lg:px-3 lg:py-[3px] text-[#747474] text-xs font-bold transition border rounded-s",
                                {
                                    "bg-primary border-primary text-white": activeChartType === 1
                                }
                            )}
                            onClick={() => setActiveChartType(1)}
                        >
                            NSE
                        </button>
                    )}
                    {!!data.bseSymbol && (
                        <button
                            className={cn(
                                "px-2 py-0.5 lg:px-3 lg:py-[3px] text-[#747474] text-xs font-bold transition border rounded-e",
                                {
                                    "bg-primary border-primary text-white": activeChartType !== 1
                                }
                            )}
                            onClick={() => setActiveChartType(2)}
                        >
                            BSE
                        </button>
                    )}
                </div>
            </div>
            {!isPaidUserPage && (
                <div className="flex flex-row items-center justify-between">
                    <h1 className="mt-4 font-Inter font-semibold text-xs lg:text-base text-primary whitespace-nowrap line-clamp-1">
                        {`${data?.compName} (${data?.title}) live share price today at ${
                            data?.nseSymbol && data?.bseSymbol ? "NSE / BSE" : data?.nseSymbol ? "NSE" : "BSE"
                        }`}
                    </h1>
                    <p className="mt-4 font-Inter font-semibold text-xs lg:text-base text-[#7d7d7d] whitespace-nowrap line-clamp-1 hidden md:block">
                        {moment().format("DD MMMM, YYYY HH:mm")} |{" "}
                        {data?.scriptData?.["NSE"] && `NSE : ${data?.scriptData?.["NSE"]?.compSymbol}`} |{" "}
                        {data?.scriptData?.["BSE"] && `BSE : ${data?.scriptData?.["BSE"]?.scriptCode}`} | ISIN:
                        {data?.isin}
                    </p>
                </div>
            )}
        </div>
    );
}
